import { toast } from "react-toastify";
import { Toast } from "../../../../config/Toast";
import Modal from "../../../../components/Modal";
import SalaryCalculationService from "../../../../services/SalaryCalculation";
import "react-toastify/dist/ReactToastify.css";

const UndoSalaryModal = (props) => {
  console.log("UndoSalaryModal", props);
  const activeModal = props.activeModal ? "effect-scale show" : "";
  const activeStyle = activeModal ? { display: "block", paddingright: "17px" } : "";

  const notifySuccess = (message) => toast.success(message, Toast);
  const notifyFailed = (message) => toast.error(message, Toast);

  const submitHandler = () => {
    const id = props.dataModal.id;

    SalaryCalculationService.undo(id)
      .then(() => {
        props.setUpdate(true);
        props.closeModal();
        notifySuccess(`Upah berhasil dikembalikan ke data awal`);
      })
      .catch((err) => {
        console.log(err.response.data.message);
        notifyFailed(err.response.data.message);
        props.closeModal();
      });
  };

  return (
    <Modal
      activeModal={activeModal}
      activeStyle={activeStyle}
      title="Undo Upah Tukang"
      closeClick={props.closeModal}
      submitHandler={submitHandler}
      type="Undo"
    >
      <h4>
        Apakah anda yakin untuk mengembalikan <br />
        <br /> upah tukang ke nilai awal ?
      </h4>
    </Modal>
  );
};

export default UndoSalaryModal;
